"use client";
import { useRef } from "react";
import PropTypes from "prop-types";

import { Tab } from "@headlessui/react";

import Listings from "components/map/listings";
import FilterSidebar from "components/map/sidebar/filter-sidebar";
import OrderDropdown from "components/listing-search/order-dropdown";
import Loading from "components/common/loading-spinner";

import styles from "./styles.module.css";

const titles = [
  {
    key: 1,
    value: "İlanlar",
  },
  {
    key: 2,
    value: "Filtreler",
  },
];

const Sidebar = ({
  categoryTree,
  listingCountItems,
  isLandPage,
  screenType,
  handleOrderDropdownChangeWithHistoryPush,
  isLoadingListing,
  newSearchResults,
  isProjectPage,
  filters,
}) => {
  const { searchCriteria, allListings } = newSearchResults || {};

  const ref = useRef(null);

  const handleChange = () => {
    if (ref.current) ref.current.scrollTop = 0;
  };

  return (
    <div className={styles.wrapper}>
      <Tab.Group onChange={handleChange}>
        <Tab.List className={styles.tabList}>
          {titles.map((item) => (
            <Tab
              key={item.key}
              className={({ selected }) => `${styles.tab} ${selected ? styles.tabselected : styles.tabnotselected}`}
            >
              {item.value}
            </Tab>
          ))}
        </Tab.List>
        {isLoadingListing ? (
          <div className={styles.loading}>
            <Loading />
          </div>
        ) : (
          <div className={styles.contentWrap} id="scrollableDiv" ref={ref}>
            <Tab.Panels className={styles.tabPanels}>
              <Tab.Panel key={1}>
                <div className={styles.orderDropdown}>
                  <OrderDropdown
                    criteria={searchCriteria}
                    handleOrderDropdownChangeWithHistoryPush={handleOrderDropdownChangeWithHistoryPush}
                    screenType={screenType}
                  />
                </div>
                <Listings listings={allListings} isLandPage={isLandPage} isProjectPage={isProjectPage} />
              </Tab.Panel>
              <Tab.Panel key={2}>
                <FilterSidebar
                  listingData={newSearchResults}
                  categoryTree={categoryTree}
                  screenType={screenType}
                  filters={filters}
                  listingCountItems={listingCountItems}
                  isProjectPage={isProjectPage}
                  newSearchResults={newSearchResults}
                />
              </Tab.Panel>
            </Tab.Panels>
          </div>
        )}
      </Tab.Group>
    </div>
  );
};

Sidebar.propTypes = {
  listingList: PropTypes.object,
  projectList: PropTypes.object,
  screenType: PropTypes.string,
  categoryTree: PropTypes.array,
  listingCountItems: PropTypes.array,
  isLandPage: PropTypes.bool,
  pathname: PropTypes.string,
  handleOrderDropdownChangeWithHistoryPush: PropTypes.func,
  isLoadingListing: PropTypes.bool,
  newSearchResults: PropTypes.object,
  filters: PropTypes.object,
};

export default Sidebar;
